var exports = {
  "I": "pill__RjCSZg",
  "K": "icon__YZuaB6",
};

module.exports = exports;
